
import './login.css';
import {useState} from 'react';
import logo from '../../assets/logo-login.png'
import { useHistory } from "react-router-dom";
import AuthenticationService from '../../service/AuthenticationService';
import { message} from 'antd';

function Login(){
    const [login, setLogin] = useState('');
    const [senha, setSenha] = useState('');
    const history = useHistory();
    const [hasLoginFailed, setHasLoginFailed] = useState(false);
    const [showSuccessMessage, setShowSucessMessage] = useState(false);

    function handleSubmit(e){
        e.preventDefault();
        if(login === '' || senha === ''){
            message.error('Preencha todos os campos!');
            setHasLoginFailed(true);
            setShowSucessMessage(false);
        }else{
            AuthenticationService
            .registerSuccessfulLogin(login, senha)
            .then(() => {
                history.push('/home')
            }).catch(() => {
                message.error('Erro ao efetuar login, verifique login e senha');
                setHasLoginFailed(true);
                setShowSucessMessage(false);
            })
        }
        
    }

    return(
        <div className='container-center'>
            <div className='login'>
                <div className='login-area'>
                    <img src={logo} alt="Logo Army"/>
                </div>
                <form onSubmit={handleSubmit}>
                    <h1>Entrar</h1>
                    <p>Para acessar use seu <span>número de inscrição</span> no <span>LOGIN</span> e na <span>SENHA</span></p>
                    <input placeholder="Login" value={login} 
                    onChange={(e) => setLogin(e.target.value)} />
                    <input type='password' placeholder="Senha"
                    value={senha} onChange={(e) => setSenha(e.target.value)} />
                    <button type="submit">Acessar</button>
                </form>
            </div>
        </div>
    );
}

export default Login;